module.exports = __webpack_public_path__ + "static/media/fig_4.bb0862ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_4.jpg
// module id = 675
// module chunks = 0